import { User } from '@alluradirect/react';

export interface UserMissingProfileInfoReturn {
  missingPhone: boolean;
  missingCompanyName: boolean;
  missingLastOrFirstName: boolean;
  missingAddressInformation: boolean;
  missingDateOfBirth: boolean;
}

// TODO: perhaps move to shared
export const userMissingProfileInfo = (user: User): UserMissingProfileInfoReturn => {
  const {
    ADDRESS: { STREET_NAME, STREET_NUMBER, CITY, REGION, COUNTRY, POSTAL },
    LAST_NAME,
    FIRST_NAME,
    PHONE,
    IS_SMS_VERIFIED,
    IS_COMPANY,
    COMPANY_NAME,
    DATE_OF_BIRTH,
  } = user;

  const ret: UserMissingProfileInfoReturn = {
    missingPhone: false,
    missingCompanyName: false,
    missingLastOrFirstName: false,
    missingAddressInformation: false,
    missingDateOfBirth: false,
  };

  if (!PHONE || !IS_SMS_VERIFIED) {
    ret.missingPhone = true;
  }

  if (IS_COMPANY && !COMPANY_NAME) {
    ret.missingCompanyName = true;
  }

  if (!IS_COMPANY && (!LAST_NAME || !FIRST_NAME)) {
    ret.missingLastOrFirstName = true;
  }

  if (!STREET_NAME || !STREET_NUMBER || !CITY || !REGION || !COUNTRY || !POSTAL) {
    ret.missingAddressInformation = true;
  }

  if (DATE_OF_BIRTH === '') {
    ret.missingDateOfBirth = true;
  }

  return ret;
};

export const isUserMissingAnyProfileInfo = (missingInfo: UserMissingProfileInfoReturn | undefined): boolean => {
  if (!missingInfo) return false;

  let isMissingInfo = false;
  Object.keys(missingInfo).forEach(key => {
    if ((missingInfo as any)[key] === true) isMissingInfo = true;
  });
  return isMissingInfo;
};
